export default {
  'dr-grid-layout-row': 'deleteRow',
  'dr-grid-layout-column': 'deleteColumn',
  'dr-expansion-panel-item': 'onDeletePanelItem',
  'dr-tab': 'onDeleteTab'
}